import React from 'react'
import { action, observable } from 'mobx'

import Ds from './ds'

class Agreements {
  @observable data = []

  @observable agreementDetail = ''

  @observable ds = new Ds()

  @action loadAllAgreements() {
    let query = `{ agreements(hash: "${ localStorage.getItem('userHash') }") { id name agreement } }`
    this.ds.query(query, (data) => {
      this.data = data.agreements
    })
  }

  @action loadAgreement(id, callback) {
    let query = `{
      agreements(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") {
        id
        name
        agreement
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      if (data.agreements && data.agreements.length > 0) {
        this.agreementDetail = data.agreements[0]
        //this.agreementDetail.agreement = this.agreementDetail.agreement.replace(/(?:\r\n|\r|\n)/g, "<br />")
  
        if (callback) {
          callback(data.agreements[0])
        }  
      } else {
        throw new Error('Error with data.')
      }
    })
  }

  @action newAgreement(row) {
    let query = `mutation {
      addAgreement(
        name: "${ row.name }",
        agreement: "${ row.agreement }",
        hash: "${ localStorage.getItem('userHash') }"
      ) { id } }`
    this.ds.query(query, (data) => {
      this.loadAllAgreements()
    })
  }

  @action updateAgreement(row) {
    let query = `mutation {
      updateAgreement(
        id: ${ row.id },
        name: "${ row.name }",
        agreement: "${ row.agreement.replace(/"/g, '\\"').replace(/\r?\r|\n/g, "\\n", ) }",
        hash: "${ localStorage.getItem('userHash') }"
      ) { id } }`
    this.ds.query(query, (data) => {
      this.loadAllAgreements()
    })
  }

  @action deleteAgreement(id) {
    const query = `mutation {
      deleteAgreement(
        id: ${ id },
        hash: "${ localStorage.getItem('userHash') }"
      ) { id } }`
    this.ds.query(query, (data) => {
      this.loadAllAgreements()
    })
  }
}

export default new Agreements()



// WEBPACK FOOTER //
// ./src/stores/agreements.js